import { render, staticRenderFns } from "./SfNotification.vue?vue&type=template&id=e04dc442&"
import script from "./SfNotification.vue?vue&type=script&lang=ts&"
export * from "./SfNotification.vue?vue&type=script&lang=ts&"
import style0 from "./SfNotification.vue?vue&type=style&index=0&id=e04dc442&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports